import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { UncontrolledTooltip } from 'reactstrap';

const CellContainer = styled.div`
  display: flex;
  flex: 1 0 100%;
  align-items: center;
  height: 100%;
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  margin: 0px -5px;
`;

class ReadOnlyCell extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
    this._spanRef = React.createRef();
  }


  render() {
    const { column, cellData, rowIndex, columnIndex, rowData } = this.props
    let inputField = cellData, editing=false;

    let id = ""+rowIndex+":"+columnIndex;
    let tooltip = null;
    if (column.tooltipGetter){
      const tooltipText = column.tooltipGetter({ column, cellData, rowIndex, columnIndex, rowData, editing });
      if (tooltipText){
        inputField = (<span ref={this._spanRef}>{inputField}</span>)
        tooltip=(<UncontrolledTooltip placement="top" target={this._spanRef}>{tooltipText}</UncontrolledTooltip>)
      }
    }
    return (
      <CellContainer className={"EditableTableCell " + (column.format || "")}
                     id={id}
      >
        { inputField }
        { tooltip }
      </CellContainer>

    );
  }


}

ReadOnlyCell.propTypes = {
  column: PropTypes.object.isRequired,
  container: PropTypes.any.isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowData: PropTypes.object.isRequired,
  columnIndex: PropTypes.number.isRequired,
  // editing: PropTypes.bool.isRequired,
  cellData: PropTypes.any
};


export default ReadOnlyCell;